import { DatabaseIdTypes } from "../../Enums/ChoiceEnums";
import { getObject } from "../ChoiceApi";
import { assertInternally } from '../Environment';

// Search for a value based on a text value
export async function genericSearch(search_id: string, searchValue?: string, allItems?: boolean): Promise<GenericSearchResult |undefined>
{
    let url = `api/Search/${search_id}?searchValue=${searchValue}`;
    if (allItems)
        url += "&allItems=true";
    
    return await getObject(url);    
}

// Fetch for a value based on an ID value
export async function fetchById(search_id: string, id: any, idType?: DatabaseIdTypes): Promise<GenericSearchResult |undefined>
{
    let url = `api/Search/${search_id}/ID?id=${id}&idType=${idType ?? DatabaseIdTypes.INVALID}`;    
    return await getObject(url);    
}


export async function searchCounties(searchText?: string): Promise<ISpecificSearchResult<ICounty>|undefined>
{
    return getObject(`api/List/Counties/Search?text=${searchText}`);
}

// Results when performing a generic search
export interface GenericSearchResult
{
    totalMatches: number,
    rows: IGenericSearchResultRow[],
    info?: IGenericResultInfo
}

// Results when performing a 'specific'/non-generic search
export interface ISpecificSearchResult<TItems>
{
    totalMatches: number,
    results: TItems[]
}


export interface IGenericSearchResultRow
{
    id_1?: string,
    id_2?: string,
    id_3?: string,
    id_4?: string,

    col_1?: string,
    col_2?: string,
    col_3?: string,
    col_4?: string,
    col_5?: string,
    col_6?: string,
    col_7?: string,
    col_8?: string,
    col_9?: string
}

export interface IGenericResultInfo
{
    totalMatches: number,
    maxResultRows: number,
    idColumns?: string[],
    dataColumns?: string[],
    headerInfo?: IResultHeaderInfo[]
}

export interface IResultHeaderInfo
{
    name: string,
    widthInPx: number
}

export interface ICounty
{
    countyFIPS: string,
    countyName: string,
    stateName: string
}

// Get the specified ID value based on the id field name
export function getIdValue(idFieldName: string, row: IGenericSearchResultRow, infoOrResults: IGenericResultInfo | GenericSearchResult): string | undefined
{
    const resultInfo: (IGenericResultInfo | undefined) = ("info" in infoOrResults && "totalMatches" in infoOrResults) ? infoOrResults.info : <IGenericResultInfo>infoOrResults;
    if (!resultInfo)
    {
        assertInternally(`Unable to get IGenericResultInfo object`);
        return;   
    }

    // Match the specified ID field name against the values specified server side
    const lowerCaseIdField = idFieldName.toLowerCase()
    const idColIndex = resultInfo.idColumns?.findIndex(colName => colName.toLowerCase() === lowerCaseIdField);
    if (!idColIndex)
    {
        assertInternally(`Unable to match idField.  Value suppiled: ${idFieldName},  ID Columns: ${resultInfo.idColumns?.join(", ")}`);
        return;
    }

    switch(idColIndex+1)
    {
        case 1:
        return row.id_1;
 
        case 2:
        return row.id_2;
 
        case 3:
        return row.id_3;
 
        case 4:
        return row.id_4;
 
        default:
        assertInternally(`Invalid idColIndex: ${idColIndex} (expected to be 1,2,3, or 4)`);
        return;
    }
}